import { apiClientWithMiddleware } from '../../../utils/API';
import { dataFetchingErrorHandler } from '../../../errors/dataFetchingErrorHandler';
export const fetchSandboxHubsSelfData = async portalId => {
  try {
    const sandboxSelfData = await apiClientWithMiddleware().get(`/sandbox-hubs/v1/self/?portalId=${portalId}`);
    return sandboxSelfData;
  } catch (e) {
    const cause = e;
    dataFetchingErrorHandler('Failed to fetch sandbox self data')(cause);
    return null;
  }
};